import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const UsageCellRoot = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  '& > .bar': { width: '60%' },
});

export const DetailCard = styled(Box)({
  padding: 16,
  marginBottom: 24,
  borderRadius: 2,
  backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
});

export const EditTotalAmountArea = styled(Box)({
  '& table': { border: 0 },
  '& table thead tr:first-of-type, & table tfoot tr:first-of-type': {
    borderTop: '1px solid #000',
  },
  '& table tbody tr:last-child td': { borderBottom: '1px solid #000' },
  '& table thead th, & table tbody td': { borderRight: 0, borderTop: 0 },
  '& table thead th:first-of-type, & table tbody td:first-of-type': {
    borderLeft: 0,
  },
  '& table tfoot td': { borderColor: 'var(--dk-line, #F9FAFB)' },
});
